import React, { useCallback, useState } from 'react';

export default function VerifyAuthData(props) {
    const { attribute, onClose, refreshUserData, verifyAttribute, verifyAttributeSubmit } = props;

    const [code, setCode] = useState('');

    const handleVerifyAttributeSubmit = useCallback(
        (code, attribute) => {
            verifyAttributeSubmit
                .execute(attribute, code)
                .then(() => {
                    refreshUserData();
                    onClose();
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        [onClose, refreshUserData, verifyAttributeSubmit]
    );

    const verifyEmail = useCallback(() => {
        handleVerifyAttributeSubmit(code, 'email');
    }, [handleVerifyAttributeSubmit, code]);

    const resendEmailVerificationCode = useCallback(() => {
        verifyAttribute.execute('email');
    }, [verifyAttribute]);

    return (
        <>
            {attribute === 'email' && (
                <div>
                    <label htmlFor="verifyCodeEmail" className="w-full mt-4 text-xs text-neutral-600 italic">
                        {_t.auth.verifyEmailInfo()}
                    </label>
                    <div className="w-full flex justify-start gap-3">
                        <input
                            type="text"
                            name="code"
                            value={code}
                            onChange={(e) => setCode(e.target.value)}
                            id="verifyCodeEmail"
                            className="mt-1 block w-1/2 rounded-md border border-slate-300 py-2 px-3 shadow-sm focus:border-slate-900 focus:outline-none focus:ring-sky-600 text-sm"
                            placeholder={_t.auth.verificationCode()}
                            required
                        />
                        <button
                            type="button"
                            onClick={verifyEmail}
                            disabled={code.length < 6}
                            className=" w-1/4 inline-flex justify-center rounded-md border border-transparent bg-slate-800 py-2 px-4 mt-1 text-sm font-medium text-white shadow-sm hover:bg-slate-900 focus:outline-none focus:ring-2 focus:ring-sky-600 focus:ring-offset-2 disabled:opacity-80 disabled:bg-slate-800"
                        >
                            {_t.auth.verify()}
                        </button>
                        <button
                            type="button"
                            className=" w-1/4 inline-flex justify-center rounded-md border border-slate-300 bg-white px-3 py-2 mt-1 text-sm font-medium leading-4 text-slate-700 shadow-sm hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-sky-500 focus:ring-offset-2"
                            onClick={resendEmailVerificationCode}
                        >
                            {verifyAttribute.isLoading ? _t.auth.sending() : _t.auth.resend()}
                        </button>
                    </div>
                </div>
            )}
        </>
    );
}
